import React from 'react'
import { Box, Grid } from '@lojinha/design-system'
import { ChangePassword } from '@lojinha/login'
import styled from 'styled-components'
import { SectionBanner } from '../../components/section-banner'
import { SectionBannerVariants } from '../../core/section-banner-variants'
import { Form } from './form'
import { useProfile, useEditProfile, useChangePassword } from './hooks'
import { Loading } from './loading'

const ProfileGrid = styled(Grid)(
  ({ theme }) => `
    margin-top: -${theme.space.x64};

    ${theme.media.below('sm')} {
      margin-top: -${theme.space.x32};
    }
  `
)

export const Profile = () => {
  const {
    loading: profileLoading,
    name,
    phoneNumber,
    cpf,
    email,
  } = useProfile()

  const {
    editUserProfile,
    loading: editProfileLoading,
    showSuccessMessage,
    setShowSuccessMessage,
    showErrorMessage,
    setShowErrorMessage,
  } = useEditProfile()

  const {
    changePassword,
    loading: changePasswordLoading,
    error: changePasswordError,
    success: changePasswordSuccess,
    reset,
  } = useChangePassword()

  if (profileLoading) return <Loading />

  return (
    <>
      <SectionBanner bannerVariant={SectionBannerVariants.EditProfile} />
      <Grid gridTemplateColumns={['repeat(12, 1fr)']}>
        <ProfileGrid
          gridColumn={['2 / 12', '2 / 12', '3 / 11']}
          gridTemplateColumns={[
            'repeat(auto-fit, minmax(1fr, 1fr))',
            'repeat(auto-fit, minmax(400px, 1fr))',
          ]}
          gridGap={'x16'}
        >
          <Box>
            <Form
              defaultValues={{ name, email, phoneNumber, cpf }}
              onSubmit={editUserProfile}
              loading={editProfileLoading}
              showSuccessMessage={showSuccessMessage}
              setShowSuccessMessage={setShowSuccessMessage}
              showErrorMessage={showErrorMessage}
              setShowErrorMessage={setShowErrorMessage}
            />
          </Box>
          <ChangePassword
            onSubmit={changePassword}
            loading={changePasswordLoading}
            error={changePasswordError}
            reset={reset}
            success={changePasswordSuccess}
          />
        </ProfileGrid>
      </Grid>
    </>
  )
}
